module.exports = "/img/auto-loan-calculator-banner.49038452.png";